module.exports = __webpack_public_path__ + "static/media/ws.9278900d.webp";